import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styles from './styles';
import { Container } from '@material-ui/core';
import * as actionsPresentaciones from '../../../../actions/nuevaPresentacion';
import * as actions from '../../../../actions/adjuntarArchivo';
import * as actionsVenatanaDialogo from '../../../../actions/ventanaDialogo';
import uploadService from '../../../../services/upload-files';
import ProgressBar from '../../../common/ProgressBar/ProgressBar';

const ModalArchivos = (props) => {
    const classes = styles();

    const cancelarSubidaDeArchivos = () => {
        if (!props.cargaFinalizada) {
            uploadService.cancelarCarga();
        } else {
            props.subiendoArchivos(false);
            props.actualizarAtriutoVentanaDialogo({ estaVisible: false });
        }

        if (props.subiendoInternacionesMasivo) {
            props.cancelarCargaMasiva();
        } else {
            props.cancelarArchivosSeleccionados();
        }
    };

    const { uploading, progressInfos } = props;
    const barras = (
        <Container disableGutters={true} className={classes.containerBars}>
            {progressInfos &&
                progressInfos.map((progressInfo, index) => (
                    <ProgressBar key={index} progressInfo={progressInfo} />
                ))}
        </Container>
    );

    const onClickModalButton = props.subiendoInternacionesMasivo
        ? props.procesarCargaMasivaInternaciones
        : props.mostrarProcesarInternacion
        ? props.procesarCargaNuevaPresentacion
        : null;

    const deshabilitarAceptar = !props.cargaFinalizada || !onClickModalButton;

    useEffect(() => {
        const ventanaConfig = {
            estaVisible: uploading,
            titulo: 'Subiendo archivos',
            contenido: barras,
            deshabilitarAceptar: deshabilitarAceptar,
            clickAceptar: () => {
                onClickModalButton();
                props.actualizarAtriutoVentanaDialogo({ estaVisible: false });
            },
            clickCancelar: cancelarSubidaDeArchivos,
        };

        props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    }, [uploading, barras, deshabilitarAceptar, onClickModalButton]);

    return null;
};

const mapStateToProps = (state) => ({
    uploading: state.adjuntarArchivoReducer.uploading,
    progressInfos: state.adjuntarArchivoReducer.progressInfos,
    cargaFinalizada: state.adjuntarArchivoReducer.cargaFinalizada,
    mostrarProcesarInternacion:
        state.adjuntarArchivoReducer.mostrarProcesarInternacion,
    subiendoInternacionesMasivo:
        state.adjuntarArchivoReducer.subiendoInternacionesMasivo,
});

const actionCreators = {
    procesarCargaNuevaPresentacion:
        actionsPresentaciones.procesarCargaNuevaPresentacion,
    procesarCargaMasivaInternaciones:
        actionsPresentaciones.procesarCargaMasivaInternaciones,

    cancelarArchivosSeleccionados: actions.cancelarArchivosSeleccionados,
    cancelarCargaMasiva: actions.cancelarCargaMasiva,
    subiendoArchivos: actions.subiendoArchivos,
    actualizarAtriutoVentanaDialogo:
        actionsVenatanaDialogo.actualizarAtriutoVentanaDialogo,
};

export default connect(mapStateToProps, actionCreators)(ModalArchivos);
